import 'dayjs/locale/th'

import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(localizedFormat)
dayjs.extend(buddhistEra)
dayjs.locale('th')

/**
 * Format a date string or Date object into a human-readable Thai format.
 * Default format: 'D MMM YYYY HH:mm' (e.g., 1 พ.ค. 2569 15:22)
 */
export const formatDate = (
  date: string | Date | number,
  formatStr = 'D MMM YYYY HH:mm',
) => {
  if (!date) return ''
  return dayjs(date).format(formatStr)
}

/**
 * Format a date string or Date object into full Thai Wedding Date format.
 * Format: 'ddddที่ D MMMM พ.ศ. BBBB' (e.g., วันอาทิตย์ที่ 14 มิถุนายน พ.ศ. 2569)
 */
export const formatThaiDate = (
  date: string | Date | number,
  formatStr = 'วันddddที่ D MMMM พ.ศ. BBBB',
) => {
  if (!date) return ''
  try {
    const d = dayjs(date)
    if (!d.isValid()) return String(date)
    return d.format(formatStr)
  } catch {
    return String(date)
  }
}

export default dayjs
